import axios from 'axios';

export default {
  fetchResellerAgent(_, id) {
    return axios.get(`/resellerAgent/${id}`)
      .then(res => res);
  },
  saveResellerAgent(_, user) {
    const tempUserObject = user;
    tempUserObject.reseller = true;

    return axios.post('/resellerAgent', tempUserObject);
  },
};
